import { render, staticRenderFns } from "./quoteform.vue?vue&type=template&id=2363604c&"
import script from "./quoteform.vue?vue&type=script&lang=js&"
export * from "./quoteform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports